import { selectors } from '@sloyd/store-base';
import { prompt, SaveToProject } from '@sloyd/ui';
import { put, select, take } from 'saga-ts';
import { $a, guid4, invokeEvent } from 'shared-base';

export function* chooseProject() {
  try {
    const projects = yield* select(selectors.tables.$projects);

    if (Object.keys(projects).length === 0) {
      const id = yield* createAndChooseProject();
      return id;
    }

    const { value, didCancel } = yield prompt.custom({
      title: 'Save to project',
      component: SaveToProject,
      componentProps: {
        projects,
      },
    });

    if (didCancel || !value) {
      return;
    }

    return value;
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}

export function* createAndChooseProject() {
  try {
    const id = guid4();

    yield put($a('PROJECTS', 'new', id));
    yield take('ADD_PROJECT_ITEM');

    return id;
  } catch (err) {
    invokeEvent('sentry', { err });
  }
}
